import React from 'react'
import './note-area-fall-2023.css'
import NoteFall2023 from './NoteFall2023/NoteFall2023'
import { getNotes, createNote, updateNote, deleteNote } from '../cardModalFall2023UtilFunctions'
import CreateNoteModal2023 from './CreateNoteModal2023/CreateNoteModal2023'

const NoteAreaFall2023 = ({userData, modalInfo, school}) => {
    const [sideBarNotes, setSideBarNotes] = React.useState([])
    const [createNoteModal, setCreateNoteModal] = React.useState(false)
    const [editNote, setEditNote] = React.useState(false)
    
    React.useEffect(() => {
        makeInitCalls();
    }, [])

    const makeInitCalls = async () => {
        if(!modalInfo.id) return
        setSideBarNotes(await getNotes(modalInfo.type, modalInfo.id))
    }

    const createAndAddNote = async (noteInfo) => {
        let newNote = await createNote(noteInfo)
        let noteArray = sideBarNotes
        noteArray.push(newNote)
        noteArray.sort((a, b) => new Date(b.date) - new Date(a.date));
        setSideBarNotes([...noteArray])
        setCreateNoteModal(false)
    }

    const updateAndReplaceNote = async (noteInfo) => {
        let updatedNote = await updateNote(noteInfo)
        let noteArray = sideBarNotes
        let index = noteArray.findIndex((note) => note.id === updatedNote.id)
        noteArray[index] = updatedNote
        setSideBarNotes([...noteArray])
        setEditNote(false)
    }

    const deleteAndRemoveNote = async (noteInfo) => {
        let deletedNote = await deleteNote(noteInfo)
        let noteArray = sideBarNotes
        let index = noteArray.findIndex((note) => note.id === deletedNote.id)
        noteArray.splice(index, 1)
        setSideBarNotes([...noteArray])
        setEditNote(false)
    }



    return(
        <div className='note-area-fall-2023__wrapper'>
            {(createNoteModal || editNote) && 
                <CreateNoteModal2023 
                    modalInfo={modalInfo}
                    userData={userData}
                    setCreateNoteModal={setCreateNoteModal}
                    createAndAddNote={createAndAddNote}
                    editNote={editNote}
                    setEditNote={setEditNote}
                    updateAndReplaceNote={updateAndReplaceNote}
                    deleteAndRemoveNote={deleteAndRemoveNote}
                    school={school}
                />
            }
            <div className='note-area-fall-2023__add-note-btn' onClick={() => setCreateNoteModal(true)}>+ Add Note</div>
            <div className='note-area-fall-2023__note-scrollable-area'>
                {sideBarNotes.map((note, index) => 
                    <NoteFall2023 
                        key={index} 
                        note={note} 
                        userData={userData} 
                        setEditNote={setEditNote} 
                        updateAndReplaceNote={updateAndReplaceNote} 
                        deleteAndRemoveNote={deleteAndRemoveNote} 
                    />)}
            </div>
        </div>
    )
}
export default NoteAreaFall2023